module.exports = __webpack_public_path__ + "static/pen-y-fan-cb4e5d589035b7f790e5bfa2f6654f6e.png";